import Icon from 'src/components/Icon';
import Button from 'src/components/Button';
import AccordionList from 'src/components/AccordionList';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useTranslation } from 'react-i18next';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useAppDispatch } from 'src/AppContext';
import { KY_EMAIL, KY_PHONE } from 'src/constants/ky';
import { pick } from 'lodash';

export default function CustomerCenter(): JSX.Element {
  const { t } = useTranslation();
  const { i18n, ready } = useTranslation(['faq']);
  const history = useCustomHistory();
  const dispatch = useAppDispatch();
  const [list, setList] = useState<string[][]>([]);

  useLayoutEffect(() => {
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  useEffect(() => {
    const faqList = i18n.store.data[i18n.languages[0]].faq;
    const keys = ['FAQ_A-001', 'FAQ_A-002', 'FAQ_B-001'];
    if (faqList) {
      const resultList = pick(faqList, keys);
      setList(Object.values(resultList));
    }
  }, [ready, i18n.languages]);

  return (
    <>
      <div className="container mt-6">
        <div className="N_20_R text-black">{t('customer/title')}</div>
        <div className="mt-6 flex">
          <Icon name="mobile" size="32" />
          <div className="N_16_M text-greyish-brown ml-3">{KY_PHONE}</div>
        </div>
        <div className="mt-3 flex">
          <Icon name="email" size="32" />
          <div className="N_16_M text-greyish-brown ml-3 break-all">{KY_EMAIL}</div>
        </div>
        <div className="N_12_M text-black mt-5">{t('customer/disclaimer1')}</div>
        <div className="N_12_R text-brown-grey mt-1">{t('customer/disclaimer2')}</div>
        <div className="mt-10 grid grid-cols-2 gap-x-3">
          <Button
            title={t('customer/phone')}
            theme="sub"
            onClick={() => {
              location.href = 'tel:' + KY_PHONE;
            }}
          ></Button>
          <Button
            title={t('customer/email')}
            theme="sub"
            onClick={() => {
              location.href = 'mailto:' + KY_EMAIL;
            }}
          ></Button>
        </div>
      </div>
      <div className="mt-8 divide-line"></div>
      <div className="container mt-8">
        <div className="flex justify-between">
          <div className="N_16_M text-black">FAQ</div>
          <div
            className="flex items-center"
            onClick={() => {
              history.push('/faq');
            }}
          >
            <div className="N_12_R text-brown-grey mr-1 cursor-pointer">{t('customer/see_all')}</div>
            <Icon name="arrow-b" size="12"></Icon>
          </div>
        </div>
        <div className="mt-4">
          <AccordionList list={list} />
        </div>
      </div>
    </>
  );
}
